import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, Form, Select, Input } from 'antd'
import StaffAction from 'redux/staff/actions'
import RolesAction from 'redux/roles/actions'

const { TextArea } = Input

const { Option } = Select

const mapStateToProps = ({ dispatch, staff, roles, user }) => ({
  dispatch,
  staff,
  user,
  roles
})

const ChangeAccountManager = ({
  roles,
  loading,
  user,
  intl: { formatMessage },
}) => {
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({
      type: RolesAction.LOAD_ALL,
    })
  }, [dispatch])


  const onFinish = values => {
    dispatch({
      type: StaffAction.SEND_BULK_SMS,
      payload: {
        role: values?.role,
        message: values?.message,
      },
    })
  }

  return (

    <div className="mb-4">
      <div className="row">
        <div className="col-md-4">
          <div className="card">
            <div className="card-body">
              <Form
                layout="vertical"
                hideRequiredMark
                onFinish={onFinish}
                form={form}
              >
                <Form.Item
                  name="role"
                  label={formatMessage({ id: 'form.label.role' })}
                  rules={[
                    { required: true, message: formatMessage({ id: 'form.error.required' }) },
                  ]}
                >
                  <Select
                    placeholder={formatMessage({ id: 'form.placeholder.role' })}
                    size="large"
                    disabled={user?.userRole !== 'Super Admin' && user?.userRole !== 'Vice Chairman'}
                  >
                    {roles?.roleInfoData?.map(o => (
                      <Option
                        key={o.name}
                        value={o.name}
                      >
                        {o.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="message"
                  label={formatMessage({ id: 'form.label.message' })}
                  rules={[{ required: true, message: formatMessage({ id: 'form.error.required' }) }]}
                >
                  <TextArea
                    size="large"
                    style={{ width: '650px', resize: 'none' }}
                    rows="5"
                    placeholder="Message"
                    disabled={user?.userRole !== 'Super Admin' && user?.userRole !== 'Vice Chairman'}
                  />
                </Form.Item>
                <Form.Item className="text-right">
                  <Button type="primary" htmlType="submit" size="large" loading={loading} disabled={user?.userRole !== 'Super Admin' && user?.userRole !== 'Vice Chairman'}>
                    {formatMessage({ id: 'action.Update' })}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default connect(mapStateToProps)(injectIntl(ChangeAccountManager))
